<div class="flying-menu-wrapper">
  <div #flyingMenuButton
    (click)="openFlyingMenu()"
    [attr.disabled]="buttonIsDisabled"
    class="button {{toggleButtonClass}}"
    data-cy="flying-menu-toggle-button">
    <span [class]="toggleButtonArrowClass" data-cy="flying-menu-toggle-button-arrow"></span>
    <ng-content select="[labelFlyingMenu]"></ng-content>
  </div>
  @if (state?.isOpen) {
    <div (focusin)="gotFocus()" class="flying-menu-dropdown-wrapper">
      <div class="flying-menu-content-wrapper">
        <ng-content select="[contentFlyingMenu]"></ng-content>
      </div>
    </div>
  }
</div>


